import { render, staticRenderFns } from "./choose-man.vue?vue&type=template&id=50b052cc&scoped=true&"
import script from "./choose-man.vue?vue&type=script&lang=js&"
export * from "./choose-man.vue?vue&type=script&lang=js&"
import style0 from "./choose-man.vue?vue&type=style&index=0&id=50b052cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b052cc",
  null
  
)

export default component.exports